import React from "react"
import style from "./BadgeList.module.scss"
import { BadgeComponent } from "./Badge"
import { Badge } from "../data/badges"

interface BadgeProps {
  badgeList: Badge[]
}

export const BadgeList: React.FC<BadgeProps> = ({ badgeList }) => {
  return (
    <div className={style.badgesList}>
      {badgeList.map((badge, index) => {
        return <BadgeComponent badge={badge} key={index} />
      })}
    </div>
  )
}
